import {Popup} from '../common/Popup'

class BookWhen {
    constructor() {
        this.bookWhen = document.querySelector('#book-when');

        if (!this.bookWhen) return;

        this.bookWhen.addEventListener('click', () => {
            console.log('bookWhen');
            this.createPopupContent();
        })
    }

    createPopupContent() {
        const div = document.createElement('div')
        div.className = 'book-when-widget';

        const iFrame = document.createElement('iframe')
        iFrame.src = 'https://bookwhen.com/jpfitness/iframe'
        iFrame.setAttribute('frameBorder', 0)
        iFrame.setAttribute('scrolling', 'yes')
        iFrame.setAttribute('seamless', 'seamless')
        div.append(iFrame);

        new Popup('info', div);
    }
}

export {BookWhen}
